import Vue from 'vue'
import Vuex from 'vuex'
import cityListAd from '@/utils/cityListAd'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userId: '',
    userInfo: {},
    currentCity: '',
    cityCode: '',
    cityListAd: cityListAd,
    images: '/static/',
    supportCities: []  // 已开通城市列表（SupportCityList 接口），index 与 cityAll 共享缓存
  },
  mutations: {
    SET_USER_ID(s, id) {
      s.userId = id
      uni.setStorageSync('userId', id)
    },
    SET_CURRENT_CITY(s, c) {
      s.currentCity = c
      uni.setStorageSync('currentCity', c)
    },
    SET_CITY_CODE(s, c) {
      s.cityCode = c
      uni.setStorageSync('cityCode', c)
    },
    SET_SUPPORT_CITIES(s, list) {
      s.supportCities = list
    }
  }
})
